import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72f6a168"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "10",
  viewBox: "0 0 10 10",
  class: "svg"
}
const _hoisted_2 = ["stroke"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "5",
  cy: "5",
  r: "5",
  stroke: "none"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "5",
  cy: "5",
  r: "4.5",
  fill: "none"
}, null, -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("g", {
      id: "Ellipse_19",
      "data-name": "Ellipse 19",
      fill: "#fff",
      stroke: _ctx.fillOrStrokeColor,
      "stroke-width": "1"
    }, _hoisted_5, 8, _hoisted_2)
  ]))
}